import { render, staticRenderFns } from "./RecentAuditTable.vue?vue&type=template&id=61150cf4&"
import script from "./RecentAuditTable.vue?vue&type=script&lang=ts&"
export * from "./RecentAuditTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports